module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-loading no-absolute"
  }, [_c('i', {
    staticClass: "u-error-flag i-icon i-icon-g-error"
  }), _vm._v(" "), _c('p', {
    staticClass: "u-error-info"
  }, [_vm._v(_vm._s(_vm.showError))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6198ee82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorPage.vue
// module id = 514
// module chunks = 1